<template>
  <div>
    <v-btn
      icon
      @click="open_dialog"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <ModalDialogForm
      v-if="show_modal_dialog"
      title="New property"
      :showModalDialog="show_modal_dialog"
      :fields_to_collect="fields_to_collect()"
      :submit_button_text="$vuetify.lang.translator('dialog.save')"
      :clear_button_text="$vuetify.lang.translator('dialog.cancel')"
      validate
      @close-dialog="hide_dialog"
      @submit="submit_action"
      :loading="loading"
    />
  </div>
</template>
  
<script>
  import ModalDialogForm from '@/components/explorer/ModalDialog'
  export default {
    components: {
      ModalDialogForm
    },
      
    name: 'AddValue',
      
    props: {
      dict_value: Boolean,
      roles: {default: ()=>({})},
    },
      
    data: () => ({
      show_modal_dialog: false,
      loading: false,

      input_types: {
        'text': {text: 'Text', default_value: ''},
        'dictionary': {text: 'Dictionary', default_value: {}},
        'list': {text: 'List', default_value: []},
        'numeric': {text: 'Number', default_value: 0},
        'numeric': {text: 'Boolean', default_value: false},
      },
    }),
      
    computed: {
      
    },
      
    mounted() {
    },
      
    methods: {
      fields_to_collect() {
        const value_input = {
              id:	"type",
              label: "Type",
              required: true,
              value: null,
              items: Object.entries(this.input_types).map(it => [it[0], it[1].text]),
              cols:	4,
              class: null,
              component: "Select",
              placeholder: "Type",
              /*item_text: 'text',
              item_value: 'value'*/
            }
        const name_dict = {
              id:	"name",
              label: "Name",
              required:	true,
              value: null,
              cols:	4,
              class: null,
              component: "TextInput",
              placeholder: "Name"
            }
        const res = []
        if (this.dict_value) {
          res.push(name_dict)
        }
        res.push(value_input)
        return [res];
      },

      open_dialog() {
        this.show_modal_dialog = true;
      },

      hide_dialog() {
        this.show_modal_dialog = false;
      },

      submit_action(form) {
        const values = Object.fromEntries(form.entries())
        this.$emit('submit',{...values,default_value: this.input_types[values.type].default_value});
        this.hide_dialog();
      },
    },
  
    watch: {
    },
  }
</script>